/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import { derived, get } from 'svelte/store';
import { augmentedTasks } from './transcripts';

import { calendarEvents } from './calendar.store';

import { patchUser } from '../data/user.data';
import { setUser, userAuthStore, userDataModel } from './auth.store';
import { goals } from './goals';

// function simpleEvent(evt: Partial<CalendarEvent>, backupUid: string): Partial<CalendarEvent> {
//     const {description, uid, start, end} = evt;
//     return {description, uid: uid || backupUid, start, end}
// }

// export const currentTranscripts = derived(transcripts, ($transcripts) => {
// 	const localDateStr = getDateStrLocal(current);
// 	const dayTranscripts: Memory[] = transcripts
// 		.filter((t) => t.meeting?.date && getDateStrLocal(new Date(t.meeting.date)) === localDateStr)
// 		.map((t, id) => transcriptToMemory(t));
//
// })

export const chatInfoStore = derived([calendarEvents, augmentedTasks, goals], ($stores) => {
  const [$calendarEvents, $augmentedTasks, $goals] = $stores;
  // console.log("Chat info events:", $calendarEvents)
  return {
    eventList: Object.values($calendarEvents.eventsByDate).flatMap((evt) => Object.values(evt)),
    taskList: $augmentedTasks,
    goalList: [...$goals.list.values()]
  };
});

export const saveOnboardingChanges = async () => {
  const $user = get(userDataModel)?.item;
  const $userAuth = get(userAuthStore);
  if (!$userAuth?.idToken) {
    throw Error('Missing userAuth idToken');
  }
  const patchedUser: Record<string, string | Record<string, string | null | string[]>> = {};
  if ($user.firstName) {
    patchedUser['firstName'] = $user.firstName;
  }
  if ($user.lastName) {
    patchedUser['lastName'] = $user.lastName;
  }
  if ($user?.profile) {
    const patchedProfile: Record<string, string | string[] | number | null | undefined> = {
      ...$user.profile
    };
    if (!$user.profile?.role) {
      delete patchedProfile['role'];
    }
    if (!$user.profile?.roles) {
      patchedProfile['roles'] = [];
    }
    if (!$user.profile?.communicationStyles) {
      patchedProfile['communicationStyles'] = [];
    }
    (patchedUser as any)['profile'] = patchedProfile;
  }
  console.warn(`Saving onboarding changes ${JSON.stringify(patchedUser)}`);

  const result = await patchUser(patchedUser, $userAuth);
  // Update the user with the patched database value (complete record)
  // Also, set the needsPatch value to false.
  await setUser(result, true, 'loaded', false);

  userDataModel.update(($userDataModel) => {
    $userDataModel.needsPatch = false;
    return $userDataModel;
  });
};
